export const SippMixin = (superclass): any =>
  class extends superclass {
    constructor(...args) {
      super(...args)

      this.regulatory_type = 'SIPP'
    }
  }
